import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M17.508 7.68a5.299 5.299 0 0 1 1.186-3.11A9.963 9.963 0 0 0 12 2a9.964 9.964 0 0 0-4.1.876v3.45A6.968 6.968 0 0 1 12 5a6.988 6.988 0 0 1 5.508 2.68ZM18.278 15.1H19.9v3.032A9.983 9.983 0 0 1 12 22a9.96 9.96 0 0 1-6.5-2.4v-4.997a7.002 7.002 0 0 0 12.778.497Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M12 17.5a5.501 5.501 0 0 1-5.435-4.65c.106-.107.207-.22.304-.338A4.494 4.494 0 0 0 7.9 9.6V8.334A5.5 5.5 0 1 1 12 17.5ZM2.4 20v-7.32a3.299 3.299 0 0 1-1.71-1.12A2.995 2.995 0 0 1 0 9.6V4h1.6v5.6h.8V4H4v5.6h.8V4h1.6v5.6c0 .747-.23 1.4-.69 1.96-.46.56-1.03.933-1.71 1.12V20H2.4ZM21.4 20v-6.4H19V8c0-1.107.39-2.05 1.17-2.83C20.95 4.39 21.893 4 23 4v16h-1.6Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }